import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private httpClient:HttpClient) { }
  sendMessage(message:any)
  {
    return this.httpClient.post('https://portfolio-79de0.firebaseio.com/people/'+message.name+'.json', message);
  }
}
